import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { colors } from '../style/constants';
import { CommutifiLogo } from '../Logo';
import { useLocaleReceiver } from '../locales/LocaleReceiver';
import './styles.scss';
interface PageLoaderProps {
  style?: React.CSSProperties;
}
export function PageLoader(t0) {
  const $ = _c(6);
  const {
    style
  } = t0;
  const intl = useLocaleReceiver("PageLoader");
  let t1;
  if ($[0] !== intl) {
    t1 = intl.formatMessage({
      id: "loadingDescription"
    });
    $[0] = intl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="column"><CommutifiLogo fill={colors.primary400} hideText={true} height={44} /><div className="spinner spinner--path" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== style || $[4] !== t1) {
    t3 = <section id="loader" data-testid="page-loader" style={style} role="status" aria-label={t1}>{t2}</section>;
    $[3] = style;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export default PageLoader;